import { ReactNode, createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getAccessControl } from "../services/AccessControl";
import { getAllowDenyStatus } from "../services/AllowStatus";
import Jumper from "../components/Jumper";

interface AccessControl {
    id: number;
    roleId: number;
    groupName: string;
    section: string;
    action: string;
    allowDenyStatusId: number;
}

const AccessControlContext = createContext({});

export const AccessControlProvider = ({ children }: { children: ReactNode }) => {
    const [userRoleId, setUserRoleId] = useState<string>(Cookies.get("roleId-express-tire") || "");
    const [permissions, setPermissions] = useState<{ [key: string]: boolean }>({});
    const [loading, setLoading] = useState<boolean>(true);

    const token = Cookies.get("token-express-tire");
    const role = Cookies.get("role-express-tire") || '';

    useEffect(() => {
        if (role.toLowerCase() === "admin") {
            setPermissions({});
            setLoading(false);
            return;
        }

        const fetchPermissions = async () => {
            setLoading(true);

            if (!userRoleId || !token) {
                setLoading(false);
                return;
            }

            try {
                const res: AccessControl[] = await getAccessControl(
                    "accessControls",
                    { roleId: userRoleId },
                    token.toString()
                );

                const statusList: any[] = await getAllowDenyStatus();
                const allowStatus = statusList.find(s => s.allowDenyName === "Allow");

                const newPermissions: { [key: string]: boolean } = {};

                res.forEach((item) => {
                    const normalizedSection = item.section
                        .replace(/\s+/g, "")
                        .replace(/-/g, "")
                        .toLowerCase();

                    newPermissions[normalizedSection] =
                        item.allowDenyStatusId === allowStatus.id;
                });

                setPermissions(newPermissions);

            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();

    }, [userRoleId, role, token]);

    return (
        <AccessControlContext.Provider
            value={{ permissions, setPermissions, userRoleId, setUserRoleId }}
        >
            {loading ? <Jumper /> : children}
        </AccessControlContext.Provider>
    );
};

export default AccessControlContext;
